import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickCallButton, trackUserProfileClick } from '../../actions/userCard/tracking';
import { UserCardActions } from '../../components/UserCardMobile/UserCardActions';
import { UserCardCallButton } from '../../components/UserCardMobile/UserCardCallButton';
import { UserCardProfileLink } from '../../components/UserCardMobile/UserCardProfileLink';
import { BLOB_ID } from '../../constants/blobId';
import { useCompanionData } from '../../hooks';
import { useIsDailyrentOnlineBooking } from '../../hooks/useIsDailyrentOnlineBooking';
import { currentChatOpponentIdSelector, currentOpenChatSelector, customActionsSelector } from '../../selectors';
import { selectIsOpponentContactsVisible } from '../../selectors/isOpponentContactsVisible';
import { UserCardMenuActionsContainer } from '../UserCardMenuActionsContainer';
import { UserCardMobileCustomActionButtonContainer } from '../UserCardMobileCustomActionButtonContainer';

const COUNT_BUTTONS_USERCARD = 3;

export const UserCardMobileActionsContainer = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const customActions = useSelector(customActionsSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);
  const isOpponentContactsVisible = useSelector(selectIsOpponentContactsVisible);

  const isDailyrentOnlineBooking = useIsDailyrentOnlineBooking();

  const { companionId, formatPhone, profileLink } = useCompanionData(currentChat?.chatId);

  const subscribeActionButton = React.useMemo(() => {
    const button = customActions
      ? customActions.find(({ action }) => action === 'unsubscribe' || action === 'subscribe')
      : undefined;

    return button || null;
  }, [customActions]);

  const customActionsWithoutSubscribe = React.useMemo(() => {
    const actions = customActions
      ? customActions.filter(({ action }) => action !== 'unsubscribe' && action !== 'subscribe')
      : [];

    return actions || [];
  }, [customActions]);

  if (!currentChat?.chatId || currentChat?.chatId === BLOB_ID) {
    return null;
  }

  const showCallButton = formatPhone && !isDailyrentOnlineBooking && isOpponentContactsVisible;

  const handleClickCallButton = () => {
    trackClickCallButton(currentChat, companionId, opponentId);
  };

  const handleClickProfile = () => {
    trackUserProfileClick(currentChat, companionId, opponentId);
  };

  const actions = [];

  if (subscribeActionButton) {
    actions.push(
      <UserCardMobileCustomActionButtonContainer button={subscribeActionButton} chatId={currentChat.chatId} />,
    );
  }

  if (showCallButton) {
    actions.push(<UserCardCallButton phone={`tel:${formatPhone}`} onClick={handleClickCallButton} />);
  }

  if (profileLink) {
    actions.push(<UserCardProfileLink userProfileUrl={profileLink} onClick={handleClickProfile} />);
  }

  const actionsLength = actions.length;

  if (actionsLength < 4 && customActions) {
    // максимум на карточке 3 кнопки с учетом телефона и ссылки на профиль
    customActionsWithoutSubscribe.slice(0, COUNT_BUTTONS_USERCARD - actionsLength).forEach(button => {
      actions.push(<UserCardMobileCustomActionButtonContainer button={button} chatId={currentChat.chatId} />);
    });
  }

  const menu = (
    <UserCardMenuActionsContainer
      customActions={customActionsWithoutSubscribe.slice(COUNT_BUTTONS_USERCARD - actionsLength)}
    />
  );

  return <UserCardActions actions={actions} menu={menu} />;
};
